import { useRef, useState } from 'react';
import { Icon } from '@/components/foundations';
import { ApiKeyField, Button, SegmentedControl, Tabs } from '@/components/forms';
import { AppShell, PageTitle } from '@/components/layout';
import { ConnectionCard } from '@/components/data';
import { API_URL, WEBHOOK } from '@/mocks/merchant';
import { ApiEndpointCard, WebhookCard, WooCommerceCard } from './components';

type Sec = 'keys' | 'hooks' | 'plugins';
const TABS: { value: Sec; label: string }[] = [
  { value: 'keys', label: 'API keys' },
  { value: 'hooks', label: 'Webhooks' },
  { value: 'plugins', label: 'Plugins' },
];

/** Integrações (API keys, webhooks, WooCommerce) — fiel a design/html/integrations.html (mock). */
export function IntegrationsPage() {
  const [env, setEnv] = useState<'test' | 'live'>('test');
  const [shown, setShown] = useState(false);
  const [tab, setTab] = useState<Sec>('keys');
  const [flash, setFlash] = useState<Sec | null>(null);
  const [tested, setTested] = useState(false);
  const refs = useRef<Record<Sec, HTMLElement | null>>({ keys: null, hooks: null, plugins: null });
  const prefix = env === 'test' ? 'sk_test_' : 'sk_live_';
  const go = (id: Sec) => {
    setTab(id);
    refs.current[id]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setFlash(null);
    requestAnimationFrame(() => setFlash(id));
  };
  const onTest = () => {
    setTested(true);
    setTimeout(() => setTested(false), 1500);
  };
  return (
    <AppShell store={{ name: 'Loja Exemplo', id: 'loj_7xmplo_123456' }}>
      <main className="content int-main">
  <PageTitle
    variant="integrations"
    title="Integrações"
    subtitle="Conecte sua loja e automatize seus pagamentos."
    actions={
      <SegmentedControl
        label="Ambiente"
        value={env}
        onChange={(v) => { setEnv(v); setShown(false); }}
        options={[{ value: 'test', label: 'Sandbox' }, { value: 'live', label: 'Produção' }]}
      />
    }
  />
  <Tabs label="Seções" items={TABS} value={tab} onChange={go} />
  <section className="int-grid">
    <ConnectionCard className={flash === 'keys' ? 'flash' : undefined} id="keys" ref={(el) => { refs.current.keys = el; }} icon="key" title="Chaves de API" subtitle="Use uma chave para autenticar suas requisições.">
      <div className="hr"></div>
      <label className="label" htmlFor="sk" style={{"fontWeight": "500", "fontSize": "16px"}}>Chave secreta</label>
      <ApiKeyField id="sk" prefix={prefix} secret="9f2c61b84d07ae35c07f3a" revealed={shown} onToggle={() => setShown(!shown)} />
      <p className="warn-line"><Icon name="alert" />Nunca compartilhe sua chave secreta.</p>
      <div className="hr"></div>
      <Button variant="outline-gold" id="newkey" onClick={() => alert('Demonstração: nova chave gerada.')} style={{"height": "60px", "padding": "0 24px", "fontSize": "17px", "fontWeight": "500"}}>Criar nova chave <span style={{"fontSize": "24px", "display": "grid"}}><Icon name="plus" /></span></Button>
    </ConnectionCard>
    <WebhookCard className={flash === 'hooks' ? 'flash' : undefined} ref={(el) => { refs.current.hooks = el; }} endpoint={WEBHOOK.endpoint} events={WEBHOOK.events} tested={tested} onTest={onTest} />
    <ApiEndpointCard url={API_URL.live} />
    <WooCommerceCard className={flash === 'plugins' ? 'flash' : undefined} ref={(el) => { refs.current.plugins = el; }} />
  </section>
</main>
    </AppShell>
  );
}
